var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "TopViews",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-top-views","viewBox":"0 0 100 100"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M68.814 32.44c-5.9-2.533-12.006-3.957-17.645-3.957-6.688 0-13.59 1.46-20.114 4.228a20.528 20.528 0 0 0-1.983 8.834c0 11.46 9.366 20.758 20.928 20.758 11.562 0 20.927-9.297 20.927-20.758 0-3.205-.73-6.3-2.113-9.105zm6.442 3.258c.443 1.898.67 3.857.67 5.847 0 14.23-11.61 25.758-25.926 25.758-14.315 0-25.928-11.528-25.928-25.758 0-1.92.212-3.81.625-5.645-7.127 4.16-13.491 9.978-18.192 17.229l.467.426a81.539 81.539 0 0 0 9.962 7.69C27.529 68.2 39.079 72.35 51.169 72.35c12.05 0 23.108-4.12 32.94-11.017a69.876 69.876 0 0 0 9.603-8.106c-4.343-7.084-11.006-13.166-18.456-17.528zM100 54.165S81.088 78 51.17 78 0 54.165 0 54.165C11.912 31.812 35 23 51.17 23 67.341 23 90.46 34.41 100 54.165z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/top-views.svg